import { render, staticRenderFns } from "./UnifiedControlDescriptor.vue?vue&type=template&id=3c62a22e&lang=pug&"
import script from "./UnifiedControlDescriptor.vue?vue&type=script&lang=js&"
export * from "./UnifiedControlDescriptor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports